import { Dialog } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import { resetOffCanvasView, selectVoiceSearchIntent } from "@/store/slices/offCanvas";
import Portal from "@/layouts/Portal";

import dynamic from "next/dynamic";
const FaMicrophone = dynamic(() => import("@/components/SVG/Fontawesome/FaMicrophone"));
const VoiceSearchTranscript = dynamic(() => import("./VoiceSearchItems/VoiceSearchTranscript"));

const VoiceSearchModal = () => {
  const dispatch = useDispatch();
  const showVoiceSearchIntent = useSelector(selectVoiceSearchIntent);

  const closeModal = () => {
    dispatch(resetOffCanvasView());
  }

  return (
    <Dialog open={showVoiceSearchIntent} as="div" className="relative z-[1055]" onClose={closeModal}>
      <div className="fixed inset-0 bg-black/60" />
      <Portal>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Dialog.Panel className="flex fixed top-12 outline-none overflow-x-hidden overflow-y-auto">
              <div className="prose relative h-56 w-80 mx-auto pointer-events-none text-body bg-body-bg rounded-md flex justify-center py-4">
                <span className="absolute text-base font-normal">Listening...</span>
                <div className="relative flex justify-center items-center">
                  <circle className="h-32 w-32 bg-accent animate-pingShort absolute opacity-20 rounded-full flex justify-center items-center"></circle>
                  <circle className="h-28 w-28 bg-accent animate-pingShort absolute opacity-70 rounded-full flex justify-center items-center"></circle>
                  <circle className="h-24 w-24 bg-accent absolute rounded-full flex justify-center items-center">
                    <FaMicrophone className="text-4xl text-white rounded-full" />
                  </circle>
                </div>
                <VoiceSearchTranscript />
              </div>
            </Dialog.Panel>
          </div>
        </div>
      </Portal>
    </Dialog>
  )
}

export default VoiceSearchModal;